<template>
  <div
    :id="data.id"
    class="bg-gradient-to-b from-[#432A9E] to-[#2050A7] pt-14 md:pt-[72px]"
  >
    <div class="container flex flex-col md:items-center">
      <div
        class="mb-14 flex flex-col text-white md:items-center md:text-center"
      >
        <div
          v-if="data.logoImage"
          v-lazy-background="getAssetUrl(data.logoImage)"
          class="mb-8 h-[49px] w-[155px] bg-contain bg-no-repeat md:h-[71px] md:w-[224px]"
        ></div>

        <UiSectionTitle
          v-if="data.title"
          :title="data.title"
          class="title mb-2 whitespace-pre-line text-3xl uppercase leading-none md:text-6xl"
          tag="h1"
        />

        <div
          v-if="data.text"
          class="mb-10 whitespace-pre-line text-md leading-[1.8rem]"
          v-html="data.text"
        />

        <div
          v-if="data.buttons && data.buttons.length > 0"
          class="flex gap-x-4"
        >
          <div v-for="(button, index) in data.buttons" :key="index">
            <UiButton
              v-if="button.isVisible"
              :modal="button.modal"
              :to="button.to"
              inverted
              :variant="button.variant"
              target="blank"
              size="md"
            >
              <span v-html="button.text" />
            </UiButton>
          </div>
        </div>
      </div>

      <div
        v-if="data.boardImage"
        class="z-[1] mb-8 max-w-[940px] md:order-last md:-mb-[160px]"
      >
        <CdnImg
          :src="handleImageSrc(data.boardImage)"
          :alt="handleImageAlt(data.boardImage)"
          loading="lazy"
          class="w-full rounded-md"
          :width="940"
          :height="561"
        />
      </div>

      <div
        v-if="data.columns"
        class="mb-8 auto-rows-auto md:mb-[104px] md:mt-4 md:grid md:grid-cols-3"
      >
        <div
          v-for="(column, i) in data.columns"
          :key="i"
          class="border-blue px-3 py-6 text-white md:flex md:flex-col md:items-center md:py-0 md:text-center"
          :class="{
            'border-b md:border-b-0 md:border-r': i !== data.columns.length - 1,
          }"
        >
          <div
            v-if="column.title"
            class="mb-2 whitespace-pre-line text-md font-bold leading-[1.8rem]"
            v-html="column.title"
          />

          <div
            v-if="column.text"
            class="mb-6 whitespace-pre-line text-sm leading-[1.225rem]"
            v-html="column.text"
          />

          <ul
            v-if="column.icons && column.icons.length"
            class="flex flex-wrap gap-2"
          >
            <li
              v-for="(icon, ii) in column.icons"
              :key="ii"
              v-lazy-background="getAssetUrl(icon)"
              class="h-10 w-10 rounded-lg bg-blue bg-contain bg-center bg-no-repeat"
            ></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import { useMediaAsset } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
</script>
